<div id="drug-sales-analysis-grid-section">
  <div
    id="drug-page-sales-grid-container"
    *ngIf="gridCounts['salesGrid'] !== 0"
  >
    <div class="drug-sales-analysis-grid-title">
      Sales growth & concentration
    </div>
    <app-drug-page-grid
      serviceFunction="getSalesGrowthData"
      [dataSettings]="dataSettings"
      [drugResearchParameters]="drugResearchParameters"
      (onDataSourceChanged)="onDataSourceChanged($event, 'salesGrid')"
      (onResearchIconClick)="onResearchIconClick($event)"
      (showResearchParameterOnGrid)="showResearchParameterOnGrid($event)"
    ></app-drug-page-grid>
  </div>
  <div
    id="drug-page-geo-grid-container"
    *ngIf="gridCounts['geoBreakoutGrid'] !== 0"
  >
    <div class="drug-sales-analysis-grid-title">Geographic mix</div>
    <app-drug-page-grid
      serviceFunction="getGeoMixData"
      [dataSettings]="dataSettings"
      [drugResearchParameters]="drugResearchParameters"
      (onDataSourceChanged)="onDataSourceChanged($event, 'geoBreakoutGrid')"
      (onResearchIconClick)="onResearchIconClick($event)"
      (showResearchParameterOnGrid)="showResearchParameterOnGrid($event)"
    ></app-drug-page-grid>
  </div>
  <div
    id="drug-page-indication-grid-container"
    *ngIf="gridCounts['indicationBreakoutGrid'] !== 0"
  >
    <div class="drug-sales-analysis-grid-title">Revenue by indication</div>
    <app-drug-page-grid
      serviceFunction="getReveueByIndicationData"
      [dataSettings]="dataSettings"
      [drugResearchParameters]="drugResearchParameters"
      (onDataSourceChanged)="
        onDataSourceChanged($event, 'indicationBreakoutGrid')
      "
      (onResearchIconClick)="onResearchIconClick($event)"
      (showResearchParameterOnGrid)="showResearchParameterOnGrid($event)"
    ></app-drug-page-grid>
  </div>
  <div
    id="drug-page-related-metric-grid-container"
    *ngIf="gridCounts['relatedMetricsGrid'] !== 0"
  >
    <div class="drug-sales-analysis-grid-title">Related metrics</div>
    <app-drug-page-grid
      serviceFunction="getRelatedMetricsData"
      [inReverseOrder]="true"
      [dataSettings]="dataSettings"
      [drugResearchParameters]="drugResearchParameters"
      (onDataSourceChanged)="onDataSourceChanged($event, 'relatedMetricsGrid')"
      (onResearchIconClick)="onResearchIconClick($event)"
      (showResearchParameterOnGrid)="showResearchParameterOnGrid($event)"
    ></app-drug-page-grid>
  </div>
  <app-pharma-research-insight-popup
    [(ticker)]="ticker"
    [(dapParamObj)]="currentDapObj"
    [(showPopup)]="showResearchPopup"
    (closePopup)="hideResearchInsightPopup()"
  ></app-pharma-research-insight-popup>
  <div
    class="popupBlockUI"
    style="
      display: none;
      border: none;
      margin: 0px;
      padding: 0px;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      opacity: 0.6;
      cursor: default;
      position: fixed;
      z-index: 100;
      background-color: rgb(0, 0, 0);
    "
  ></div>
</div>
